import React, { useEffect } from 'react';
import {
    CreateNewPortalUserFormData,
    portalUserSettingsFieldsName,
} from '../utils';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { APIErrorInterface, ReduxState } from '../../../store/types';
import { ConfigData } from '../../../store/types/ConfigData';
import { PortalUsersErrors } from '../../../services/apiErrors';
import { ErrorTabInteface } from '../../Forms/RingGroups/generalFormUtils';
import { actions } from '../../../store';
import { isAnyKeyFromSearchExistInSource } from '../../../utils/isAnyKeyFromSearchExistInSource';

import i18n from '../../../services/i18n';
import { RoleUserItem } from '../../../store/actions/company/payloads';
import GeneralSettingsSection from './GeneralSettingsSection';
import StatusSection from './StatusSection';

const PortalUserSettings: React.VFC<
    ErrorTabInteface & {
        isSupervisor?: boolean;
        roleList?: RoleUserItem[];
        apiErrors?: APIErrorInterface;
        hidePassword?: boolean;
    }
> = ({
    tabIndex,
    tabName,
    callback,
    callback2,
    isSupervisor,
    roleList,
    apiErrors,
    hidePassword,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const config = useSelector<ReduxState, ConfigData | undefined>(
        (state) => state.generic?.configData,
    );

    const {
        values,
        handleChange,
        errors,
        setFieldValue,
        setFieldError,
        initialValues,
    } = useFormikContext<CreateNewPortalUserFormData>();

    const markTabAsHaveError = (setTabError: boolean) => {
        if (tabName && tabIndex !== undefined) {
            dispatch(
                actions.setErrorInTab({
                    name: tabName,
                    index: tabIndex,
                    markAsInvalid: setTabError,
                }),
            );
        }
    };


    useEffect(() => {
        const errorsKeys = Object.keys(errors);
        if (
            isAnyKeyFromSearchExistInSource(
                errorsKeys,
                portalUserSettingsFieldsName,
            )
        ) {
            markTabAsHaveError(true);
        } else {
            markTabAsHaveError(false);
        }
    }, [errors, values]);

    useEffect(() => {
        if (
            apiErrors?.faultstring.includes(PortalUsersErrors.PortalUserExist)
        ) {
            setFieldError(
                'login',
                t('errors:portalUsers.loginExists', { value: values.login }),
            );
            markTabAsHaveError(true);
            callback && callback();
        }

        if (apiErrors?.faultstring.includes(PortalUsersErrors.PasswordError)) {
            setFieldError(
                'password',
                i18n.t<string>('errors:extensions.portalPasswordUpdate'),
            );
            markTabAsHaveError(true);
            callback && callback();
        }

        if (
            apiErrors?.faultcode ==
            'Server.Customer.error_during_update_customer_individual'
        ) {
            setFieldError('extension', t('errors:portalUsers.accountIsUsed'));
            markTabAsHaveError(true);
            callback && callback();
        }
    }, [apiErrors]);



    // @ts-ignore
    return (
        <>
            <GeneralSettingsSection
                values={values}
                initialValues={initialValues}
                handleChange={handleChange}
                hidePassword={hidePassword || false}
                errors={errors}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
                roleList={roleList}
                callback2={callback2}
                config={config}
                isSupervisor={isSupervisor}
            />

            <StatusSection
                values={values}
                initialValues={initialValues}
                handleChange={handleChange}
                errors={errors}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}

            />
        </>
    );
};

export default PortalUserSettings;
